import type {Difficulties} from '../constants/wow';

export type LootsheetLockId = Nominal<number, 'LootsheetLock'>;

export interface LootsheetLockData {
	readonly id: LootsheetLockId;
	readonly guildId: GuildId;
	readonly actorUserId: UserId;

	readonly createdAt: string | Date;

	readonly wowInstanceId: WowInstanceId;
	readonly difficulty: Difficulties;
}

export class LootsheetLock implements LootsheetLockData {
	readonly id: LootsheetLockId;
	readonly guildId: GuildId;
	readonly actorUserId: UserId;

	readonly createdAt: Date;

	readonly wowInstanceId: WowInstanceId;
	readonly difficulty: Difficulties;

	constructor(data: LootsheetLockData) {
		this.id = data.id;
		this.guildId = data.guildId;
		this.actorUserId = data.actorUserId;

		this.createdAt = new Date(data.createdAt);

		this.wowInstanceId = data.wowInstanceId;
		this.difficulty = data.difficulty;
	}
}
